module.exports = __webpack_public_path__ + "img/OptiCAM-logo.84602826.svg";